import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sprig from "../components/Sprig";
import { useLang } from "../i18n/LanguageContext";
import usePageMeta from "../hooks/usePageMeta";

export default function NotFound() {
  const { lang } = useLang();
  const sq = lang === "sq";
  usePageMeta(sq ? "Faqja nuk u gjet — Amora Weddings" : "Page not found — Amora Weddings");

  return (
    <>
      <Navbar />
      <Center>
        <Sprig width={48} color="#C9B68E" style={{ marginBottom: 24 }} />
        <h1>404</h1>
        <p>{sq ? "Kjo faqe nuk ekziston ose është zhvendosur." : "This page doesn't exist or has moved."}</p>
        <Link to="/">{sq ? "← Kthehu në fillim" : "← Back home"}</Link>
      </Center>
    </>
  );
}

const Center = styled.div`
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  h1 {
    font-family: ${({ theme }) => theme.font.display};
    font-size: clamp(56px, 12vw, 96px);
    font-weight: 600;
    color: ${({ theme }) => theme.colors.green};
    line-height: 1;
  }
  p { margin: 14px 0 26px; color: ${({ theme }) => theme.colors.inkSoft}; font-size: 17px; }
  a {
    background: ${({ theme }) => theme.colors.green};
    color: ${({ theme }) => theme.colors.cream};
    padding: 13px 28px;
    border-radius: 100px;
    font-weight: 500;
    font-size: 15px;
  }
`;
